import { render, staticRenderFns } from "./selectGoodsMonitor.vue?vue&type=template&id=2300153f&scoped=true"
import script from "./selectGoodsMonitor.vue?vue&type=script&lang=js"
export * from "./selectGoodsMonitor.vue?vue&type=script&lang=js"
import style0 from "./selectGoodsMonitor.vue?vue&type=style&index=0&id=2300153f&prod&lang=scss&scoped=true"
import style1 from "./selectGoodsMonitor.vue?vue&type=style&index=1&id=2300153f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2300153f",
  null
  
)

export default component.exports